import { Modal } from '../Modal/Modal';
import { useTranslation } from 'react-i18next';
import { useBreakpointFlag } from 'utils/hooks/useBreakpointFlag';
import { Container, Text } from './SubmitConfirmedModal.styled';

export interface ISubmitConfirmedModalProps {
  isOpen: boolean;
}

export function SubmitConfirmedModal({ isOpen }: ISubmitConfirmedModalProps) {
  const { t } = useTranslation();
  const { isPhone } = useBreakpointFlag();

  return (
    <Modal
      isOpen={isOpen}
      onClose={() => null}
      showCloseIcon={false}
      modalStyle={{
        margin: 'auto',
        height: 'fit-content',
        width: isPhone ? '90%' : '600rem',
        minWidth: isPhone ? '90%' : 'auto',
        position: 'fixed',
      }}
      pwId="submit-confirmed-modal"
    >
      <Container>
        <Text>{t('Your configuration has been submitted.')}</Text>
        <Text>{t('You can now close this page.')}</Text>
      </Container>
    </Modal>
  );
}
